// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__vKqMh","loaderOuter":"PageOverlayLoader_loaderOuter__bltET"};